import '../stylesheets/pyxis.sass';
import '../javascripts/jquery_global';
import 'bootstrap';
import * as Routes from '../javascripts/routes/routes.js.erb';
import 'jquery-ujs';
import '../javascripts/pyxis/util';

window.Routes = Routes;
